<div class="container">
  <div class="row min-vh-100 align-items-center justify-content-center">
    <div class="col-12 col-md-8 col-lg-5">
      <div class="card shadow-lg border-0 forgot-password-card">
        <div class="card-body p-5">
          <!-- Icon -->
          <div class="icon-wrapper text-center mb-4">
            <div class="forgot-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                <circle cx="12" cy="16" r="1"></circle>
              </svg>
            </div>
          </div>

          <!-- Titre et description -->
          <h2 class="text-center fw-bold mb-3">Mot de passe oublié ?</h2>
          <p class="text-center text-muted mb-4">
            Pas de problème. Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.
          </p>

          <!-- Formulaire -->
          <form #forgotPasswordForm="ngForm" (ngSubmit)="onSubmit()">
            <div class="mb-4">
              <label for="email" class="form-label fw-semibold">Adresse email</label>
              <div class="input-group">
                <span class="input-group-text bg-light border-end-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </span>
                <input 
                  type="email" 
                  class="form-control border-start-0 ps-0" 
                  id="email" 
                  name="email"
                  [(ngModel)]="email"
                  placeholder="exemple@email.com"
                  required
                  email
                  #emailInput="ngModel">
              </div>
              <div *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched)" class="text-danger small mt-1">
                <div *ngIf="emailInput.errors?.['required']">L'email est requis</div>
                <div *ngIf="emailInput.errors?.['email']">Email invalide</div>
              </div>
            </div>

            <!-- Message de succès -->
            <div *ngIf="emailSent" class="alert alert-success d-flex align-items-center mb-4" role="alert">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
              <div>
                Un email a été envoyé à <strong>{{email}}</strong>. Vérifiez votre boîte de réception.
              </div>
            </div>

            <!-- Message d'erreur -->
            <div *ngIf="error" class="alert alert-danger d-flex align-items-center mb-4" role="alert">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-2">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
              <div>{{error}}</div>
            </div>

            <!-- Bouton submit -->
            <div class="d-grid mb-4">
              <button 
                type="submit" 
                class="btn btn-primary btn-lg"
                [disabled]="forgotPasswordForm.invalid || isLoading">
                <span *ngIf="!isLoading">Envoyer le lien</span>
                <span *ngIf="isLoading">
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Envoi en cours...
                </span>
              </button>
            </div>

            <!-- Lien retour -->
            <div class="text-center">
              <a routerLink="/signin" class="text-decoration-none">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-1">
                  <line x1="19" y1="12" x2="5" y2="12"></line>
                  <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Retour à la connexion
              </a>
            </div>
          </form>

          <!-- Aide -->
          <div class="mt-4 pt-4 border-top text-center">
            <p class="text-muted small mb-0">
              Vous n'avez pas reçu l'email ? Vérifiez vos spams ou 
              <a href="mailto:support@referio.be" class="text-decoration-none">contactez le support</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>